import t from "@ext/localization/locale/translate";
import { IconButton } from "@ui-kit/Button";
import type { ReactNode } from "react";

type Props = {
	onRemove?: () => void;
	children: ReactNode;
};

export const AttachmentTile = ({ onRemove, children }: Props) => (
	<div className="group relative size-20 shrink-0 overflow-hidden rounded-lg border-[0.5px] border-secondary-border bg-secondary-bg">
		{children}
		{onRemove && (
			<IconButton
				aria-label={t("agent.tooltips.remove-attachment")}
				className="absolute right-0.5 top-0.5 size-5 p-0.5 opacity-0 bg-background group-hover:opacity-100 focus-visible:opacity-100"
				icon="x"
				iconClassName="size-2.5"
				onClick={onRemove}
				size="xs"
				variant="ghost"
			/>
		)}
	</div>
);
